import React from "react";

import { Input } from "./input";

interface INumericInputProps {
  value: number;
  onChange: (value: number) => void;
  placeholder?: string;
  className?: string;
  id?: string;
  disabled?: boolean;
  /** `currency` = centavos / 2 decimais (pt-BR). `integer` = contagem inteira (ex.: dias). */
  variant?: "currency" | "integer";
}

export const NumericInput: React.FC<INumericInputProps> = ({
  value = 0,
  onChange,
  placeholder,
  className,
  id,
  disabled = false,
  variant = "currency",
}) => {
  const resolvedPlaceholder =
    placeholder ?? (variant === "integer" ? "0" : "0,00");

  const formatNumber = (val: number): string => {
    if (variant === "integer") {
      return String(Math.trunc(val));
    }
    return val.toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;

    const numbersOnly = inputValue.replace(/\D/g, "");
    if (variant === "integer") {
      const numericValue = parseInt(numbersOnly, 10) || 0;
      onChange(numericValue);
      return;
    }
    // Divide por 100 para converter centavos em número decimal
    const numericValue = (parseInt(numbersOnly, 10) || 0) / 100;

    onChange(numericValue);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const key = event.key;

    if (
      !/[0-9]/.test(key) &&
      ![
        "Backspace",
        "Delete",
        "Tab",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
      ].includes(key)
    ) {
      event.preventDefault();
    }

    if (/[0-9]/.test(key)) {
      event.preventDefault();
      const digit = parseInt(key, 10);
      if (variant === "integer") {
        onChange(value * 10 + digit);
        return;
      }
      // Multiplica por 10 para adicionar o dígito e depois divide por 100
      const newValue = (value * 100 * 10 + digit) / 100;

      onChange(newValue);
    }
  };

  const displayValue = formatNumber(value);

  return (
    <div className="space-y-1">
      <Input
        value={displayValue}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        id={id}
        placeholder={resolvedPlaceholder}
        className={className}
        disabled={disabled}
        onPaste={(e) => e.preventDefault()}
      />
    </div>
  );
};

